import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RolesPermissionRoutingModule } from './roles-permission-routing.module';
import { FormsModule } from '@angular/forms';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { ManageComponent } from './manage/manage.component';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { AddAdminComponent } from './add-admin/add-admin.component';

@NgModule({
  declarations: [ManageComponent, AddAdminComponent],
  imports: [
    CommonModule,
    RolesPermissionRoutingModule,
    FormsModule,
    NzTableModule,
    NzDividerModule,
    NzTagModule,
    NzSpinModule,
    NzModalModule,
    NzSelectModule,
    NzButtonModule,
    NzInputModule,
    NzIconModule,
    NzGridModule,
    NzSwitchModule,
  ],
})
export class RolesPermissionModule {}
